import { Injectable } from '@angular/core';
import { BlockResources } from '@zorro/apiclient';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class TextResourceService {
  private readonly store = new BehaviorSubject<BlockResources[]>([]);
  private currentState: BlockResources[];

  constructor() {
    this.store.subscribe((state: BlockResources[]) => this.currentState = state);
  }

  setResources(resources: BlockResources[]): void {
    const fState = this.currentState.filter(x => resources.every(y => y.block !== x.block));
    const nState = fState.concat(resources);
    this.store.next(nState);
  }

  getResources(componentName: string): Observable<{ [key: string]: string }> {
    return this.store.pipe(map((resources: BlockResources[]) => {
      const res = resources.find(x => x.block === componentName);
      return res ? res.resources : {};
    }));
  }
}
